export function diffArraysByKey(a, b, key) {
    if (!Array.isArray(a) || !Array.isArray(b) || !key) {
        return [];
    }
    const ids = b.filter(el => el[key]).map(el => el[key]);
    const safe = a.filter(el => el[key]);
    const diff = safe.filter(entry => !ids.includes(entry[key])).filter(Boolean);
    return diff;
}
